/** Скільки від вартості підписки можна закрити бонусами.
 *
 * ОДНА цифра на весь застосунок. Має збігатися з
 * `MAX_BONUS_SHARE_OF_PAYMENT` у `src/inflow/services/bonuses.py`.
 *
 * Owner 2026-09-01 підняв стелю 30% → 50%, але на сервері. У застосунку
 * лишалась зашита 0.3 у двох місцях і текст «до 30%» — людина бачила знижку
 * 90 ₴ там, де мала бути 150 (owner 2026-09-05).
 */
export const MAX_BONUS_SHARE = 0.5;

/** Та сама цифра словами — для текстів. */
export const MAX_BONUS_PERCENT = Math.round(MAX_BONUS_SHARE * 100);
